import { FirestoreService } from '../firebase/firestore';

/**
 * Test Firebase connection and table creation
 */
export const testFirebaseConnection = async () => {
  console.log('🧪 Testing Firebase connection...');
  
  try {
    // Test 1: Try to get existing tables
    console.log('📋 Test 1: Fetching existing tables...');
    const existingTables = await FirestoreService.getTables();
    console.log('✅ Successfully fetched tables:', existingTables);
    console.log('📊 Number of tables:', existingTables.length);
    
    // Test 2: Try to add a single test table
    console.log('\n📝 Test 2: Adding a test table...');
    const testTable = {
      tableNumber: 'TEST-01',
      status: 'available' as const,
      capacity: 4,
      location: 'Test Area'
    };
    
    console.log('📤 Attempting to add:', testTable);
    const tableId = await FirestoreService.addTable(testTable);
    
    if (tableId) {
      console.log('✅ Test table added successfully with ID:', tableId);
      
      // Test 3: Verify the table was added
      console.log('\n🔍 Test 3: Verifying table was added...');
      const verifyTables = await FirestoreService.getTables();
      console.log('📊 Tables after adding:', verifyTables);
      
      // Test 4: Delete the test table
      console.log('\n🗑️ Test 4: Cleaning up test table...');
      const deleted = await FirestoreService.deleteTable(tableId);
      if (deleted) {
        console.log('✅ Test table deleted successfully');
      } else {
        console.log('⚠️ Failed to delete test table');
      }
      
      return {
        success: true,
        message: 'All tests passed! Firebase is working correctly.',
        tableId
      };
    } else {
      console.error('❌ Failed to add test table - no ID returned');
      return {
        success: false,
        message: 'Failed to add table to Firebase. Check console for errors.'
      };
    }
  } catch (error) {
    console.error('❌ Firebase test failed:', error);
    if (error instanceof Error) {
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
    }
    return {
      success: false,
      message: `Firebase error: ${error instanceof Error ? error.message : 'Unknown error'}`,
      error
    };
  }
};
